import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { EmailContentAttachmentSize } from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'

export const EMAIL_CONTENT_BLOCK_VERTICAL_PADDING = sharedStyles.Spacings.NORMAL
export const EMAIL_CONTENT_BLOCK_HORIZONTAL_PADDING = sharedStyles.Spacings.MEDIUM
export const EMAIL_CONTENT_VERTICAL_SPACING = sharedStyles.Spacings.SMALL

export const AttachmentWidthModifierMap: Partial<Record<EmailContentAttachmentSize, number>> = {
  [EmailContentAttachmentSize.S]: 0.3,
  [EmailContentAttachmentSize.M]: 0.6,
}
export const ATTACHMENT_DEFAULT_WIDTH_MODIFIER = 1
